// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./HomePageSlides.module.css";
// CSS
// Models
import { I_HomePageSlides } from "../../../Models/interfaces";
// Models
// Services
import { getHomePageSlides_Service } from "../../../Services/Home/get/getHomePageSlides_Service";
// Services
// Modules
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./SwiperManager.css";
import { Pagination, Mousewheel, Keyboard, Autoplay } from "swiper";
// Modules
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
// Skeleton

const HomePageSlides = () => {
  const userToken = useContext(UserTokenContext);
  const [slides, setSlides] = useState<I_HomePageSlides[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);

  useEffect(() => {
    if (userToken === "init" || "") return;

    getHomePageSlides_Service(userToken)
      .then(({ data: { data } }) => {
        setSlides(data);
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);

  return (
    <div
      className={`${styles.homePageSlideContainer} flex items-center justify-center  relative pb-0`}
    >
      {isPending ? (
        <>
          <SkeletonTheme
            baseColor="rgba(126, 58, 229 , 0.1)"
            highlightColor="rgba(126, 0, 229, 0.6)"
          >
            <p>
              <Skeleton
                count={1}
                width={"calc(100vw - 2rem)"}
                height={"150px"}
                style={{ marginTop: "1rem" }}
              />
            </p>
          </SkeletonTheme>
        </>
      ) : (
        <>
          <Swiper
            spaceBetween={8}
            slidesPerView={1}
            className="mt-2"
            direction="horizontal"
            centeredSlides={true}
            initialSlide={0}
            pagination={{
              clickable: true,
              el: `.swiperPagination`,
            }}
            speed={500}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop
            modules={[Pagination, Mousewheel, Keyboard, Autoplay]}
          >
            {slides.map((item) => (
              <SwiperSlide
                key={item.url}
                className="flex items-center justify-center rounded-3xl"
              >
                <img
                  src={item.url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                  className="w-full h-full rounded-3xl"
                  alt={item.title + " Slide !"}
                  style={{ width: "100%", height: "20vh" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={`swiperPagination`}></div>
        </>
      )}
    </div>
  );
};

export default HomePageSlides;
